import { saveAs } from "file-saver";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AppRoutes } from "../../../constants/appRoutes";
import { DateHelper } from "../../../helpers/dateHelper";
import FilterHelper from "../../../helpers/filterHelper";
import { buildRegionizeRoute } from "../../../helpers/regionRouteHelper";
import { Spacing } from "../../../shared/components/common/spacing";
import DataTableGrid from "../../../shared/formUtilities/useTable";
import { InitializeColumnsDFSAOpportunities } from "../reportsColumn";
import { ReportsService } from "../reportsService";
import { DFSAOpportunitiesFilter } from "./dfsaOpportunitiesFilter";

const DFSAInvestorOpportunities = () => {
  const reportsService = new ReportsService();
  const queryParameters = new URLSearchParams(window.location.search);
  const [reports, setReports] = useState([]);
  const [loading, setloading] = useState(false);
  const navigate = useNavigate();
  const columns = InitializeColumnsDFSAOpportunities();
  const [filter, setFilter] = useState(
    {
      fromDate: '',
      toDate: '',
    }
  );

  useEffect(() => {
    getAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.location.search]);

  const getAll = () => {
    let filter = FilterHelper.mapFilters(queryParameters);
    setloading(true);
    reportsService
      .getDFSAOpportunityReport(filter)
      .then((resp) => {
        setFilter(filter);
        setloading(false);
        setReports(resp.data);
      })
      .catch((err) => {
        setloading(false);
      });
  };

  const onDownloadCSV = () => {
    setloading(true);
    let filter = FilterHelper.mapFilters(queryParameters);
    reportsService
      .exportDFSAOpportunityReport(filter)
      .then((resp) => {
        const date = DateHelper.formatDate(new Date());
        const fileName = `DFSA-Investors-in-Opportunities-Report-${date}.csv`;
        saveAs(resp.data, fileName);
        setloading(false);
      })
      .catch((err) => {
        setloading(false);
      });
  };

  function onNavigate(filterObj = filter) {
    let filterParams = filterObj ? FilterHelper.mapToParams(filterObj, false, true) : '';
    filterParams = filterParams?.replace('&', '');
    navigate({
      pathname: buildRegionizeRoute(
        `${AppRoutes.Reports}/${AppRoutes.ReportDFSAOpportunities}`
      ),
      search: `?${filterParams}`,
    });
  }


  function onFilter(values) {
    setFilter(values);
    onNavigate(values);
  }

  function onClearFilter(values) {
    onFilter(values);
  }

  return (
    <>
      <DFSAOpportunitiesFilter filter={filter}
        onHandleFilter={onFilter}
        onClearFilter={onClearFilter} />
      <Spacing />
      <DataTableGrid
        showDownloadCSV={true}
        download={() => {
          onDownloadCSV();
        }}
        name={'dfsaOpportunitiesReportTbl'}
        columns={columns}
        hideSerialNumbers
        heading={'DFSA-Investor in Opportunities'}
        records={reports}
        isPagination={false}
        showEditColumnsButton={true}
        loading={loading}></DataTableGrid>
    </>
  );
};

export default DFSAInvestorOpportunities;